import { create } from 'zustand'
import { dbgEvent } from '../lib/debug'

export type ConnectionStatus = 'online' | 'reconnecting' | 'offline'

interface ConnectionStoreState {
  status: ConnectionStatus
  setStatus: (status: ConnectionStatus) => void
}

export const useConnectionStore = create<ConnectionStoreState>((set) => ({
  status: 'online',

  setStatus: (status) => {
    dbgEvent('Zustand', 'connection.setStatus', { status })
    set({ status })
  },
}))
